import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Col, Row, Button, Form, FormGroup, Label } from 'reactstrap';
import { validateCompanyDetails } from './helper';
import{corporateCategoryList} from '../../../../../constants'
class CompanyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            nonCorporateDBReportAllowed: false
        }
    }

    saveCompanyNameDetails(event) {
        let msg = validateCompanyDetails(this.props.companyDetails.values, this.props.initialValues['corporate-type']);
        if (msg === '') {
            if (this.props.updateFlagOnSave) {
                this.setState({
                    errorMsg: ''
                }, () => { this.props.saveCompanyNameDetailsCallback(event, this.props.companyDetails.values, true); })

            }
            else {
                this.setState({
                    errorMsg: ''
                }, () => { this.props.saveCompanyNameDetailsCallback(event, this.props.companyDetails.values, false); })

            }
        }
        else {
            this.setState({
                errorMsg: msg
            })
        }
        event.preventDefault();
    }

    handleNonCorpDBReportChange = (event) => {
        const value = event.target.value === 'true';
        this.setState({ nonCorporateDBReportAllowed: value });
    }

    render() {
        let fullStatesList = this.props.stateList.map(p => {
            return (
                <option key={p} value={p}>{p}</option>
            )
        })
        let corporateCategory = corporateCategoryList.map(p => {
            return (
                <option key={p} value={p}>{p}</option>
            )
        })
        return (
            <Form>
                <FormGroup className={this.props.initialValues['corporate-type'] ? "d-inline-flex mr-4 corporate-type ml-1" : "d-inline-flex mr-4 corporate-type ml-1 hidden"} check>
                    <Label>
                        <Field className="input-type-radio" name="corporate-type" component="input" type="radio" value="Subsidiary" id="corporate-type-subsidiary" />
                        Subsidiary
                    </Label>
                </FormGroup>
                <FormGroup className={this.props.initialValues['corporate-type'] ? "d-inline-flex corporate-type" : "d-inline-flex corporate-type hidden"} check>
                    <Label>
                        <Field className="input-type-radio" name="corporate-type" component="input" type="radio" value="Division" id="corporate-type-subsidiary" />
                        Division
                    </Label>
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="company-name">Company Name<span className="text-danger">*</span></Label>
                    <Field name="companyName" component="input" type="text" placeholder="Company Name" className='mb3 form-control' />
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="company-address">Company Address<span className="text-danger">*</span></Label>
                    <Field name="company-address1" component="input" type="text" placeholder="Plot No. / Complex / Street ..." className='mb-3 form-control' />
                    <Row className="mb-3">
                        <Col>
                            <Field name="company-address-city" component="input" type="text" placeholder="City" className='mb-3 form-control' />
                        </Col>
                        <Col className="pl-0">
                            <Field id="company-address-state" name="company-address-state" component="select" className='mb3 form-control'>
                                <option>Select state</option>
                                {fullStatesList}
                            </Field>

                        </Col>
                    </Row>
                    <Field name="zipCode" component="input" type="text" placeholder="Zip code" className='mb3 form-control' />
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="gst">GST Number<span className="text-danger">*</span></Label>
                    <Field name="GST-Number" component="input" type="text" placeholder="22-AAAA0000A-1Z5" id="gst" className='mb-3 form-control' />
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="pan">PAN Number<span className="text-danger">*</span></Label>
                    <Field name="PAN-Number" component="input" type="text" placeholder="AAAPL1234C" id="pan" className='mb-3 form-control' />
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="tan">TAN Number</Label>
                    <Field name="TAN-Number" component="input" type="text" placeholder="NGPO02911A" id="tan" className='mb-3 form-control' />
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="tan">Corporate Category<span className="text-danger">*</span></Label>
                    <Field name="corporate-category" component="select" placeholder="category" id="corporate-category" className='mb-3 form-control'>
                    <option>Select Category</option>
                    {corporateCategory}
                    </Field>
                </FormGroup>
                <FormGroup className="mb-4">
                    <Label for="tan">Non Corporate Database Report Allowed ?</Label>
                    <Row>
                        <Col className="d-inline-flex mr-1">
                            <Field name="non-corporate-db-report-allowed" component="input" type="radio" 
                                value="true" id="dbReportYes" className='input-type-radio'/>
                            <Label for="dbReportYes" className='ml-2'>Yes</Label>
                        </Col>
                        <Col className="d-inline-flex mr-1">
                            <Field name="non-corporate-db-report-allowed" component="input" type="radio" 
                                value="false" id="dbReportNo" className='input-type-radio'/>
                            <Label for="dbReportNo" className='ml-2'>No</Label>
                        </Col>
                    </Row>
                    </FormGroup>
                <FormGroup>
                    <Button type="submit" className="d-block ml-auto" color="primary" onClick={(event) => this.saveCompanyNameDetails(event)}>Save</Button>
                </FormGroup>
                <div className='error'>{this.state.errorMsg}</div>
            </Form>
        )
    }

}

CompanyDetails = reduxForm({
    form: 'companyDetailsForm',
    enableReinitialize: true
})(CompanyDetails)



const mapStateToProps = (state, ownProps) => ({
    companyDetails: state.form.companyDetailsForm,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default CompanyDetails = connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyDetails)